export const Layers = {
  SplashContainer: {
    zIndex: 1010,
  },
  AdsContainer: {
    zIndex: 1010,
  },
  DisplayContainer: {
    zIndex: 1020,
  },
  PromoContainer: {
    zIndex: 1030,
  },
  Console: {
    zIndex: 1100,
  },
};
